import { styled } from 'baseui'
import { pollColor } from '@/shared/tools/communicationBoardPolls'

interface FaceButtonProps {
  $colorKey: string
  $softColorKey: string
  $selected: boolean
  $dimmed: boolean
}

export const FaceButton = styled<'button', FaceButtonProps>(
  'button',
  ({ $theme, $colorKey, $softColorKey, $selected, $dimmed }) => {
    const color = pollColor($theme, $colorKey)

    return {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      width: '2.25rem',
      height: '2.25rem',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      borderRadius: '999px',
      border: `2px solid ${$selected ? color : 'transparent'}`,
      backgroundColor: $selected ? color : pollColor($theme, $softColorKey),
      color: $selected ? $theme.colors.white : color,
      opacity: $dimmed ? 0.45 : 1,
      cursor: 'pointer',
      transform: $selected ? 'scale(1.08)' : 'none',
      transitionProperty: 'transform, opacity, background-color',
      transitionDuration: '120ms',
      ':hover': { opacity: 1, transform: 'scale(1.08)' },
      ':focus-visible': { outline: 'none', boxShadow: `0 0 0 0.1875rem ${$theme.colors.accent}` },
      '@media (prefers-reduced-motion: reduce)': { transitionDuration: '0ms' },
    }
  },
)
